import { call, put, select, takeEvery } from 'redux-saga/effects';
import get from 'lodash/get';

import { request } from 'components/Fetch';
import urls from 'config/urls';
import { QuickpayConstants } from 'constants/quickpay';
import { getPaymentAccountsAction } from 'actions/quickpay';

function* getQuickpay(action) {
  yield call(request({
    type: QuickpayConstants.GET_QUICKPAY,
    method: 'GET',
    url: urls.getQuickpay(),
  }), action);
}

function* getPaymentAccounts(action) {
  const loanId = yield select((state) => state.quickpay.data.loanId);
  yield call(request({
    type: QuickpayConstants.GET_PAYMENT_ACCOUNTS,
    method: 'GET',
    url: urls.getQuickpayPaymentAccounts(loanId),
  }), action);
}

function* addPaymentAccounts(action) {
  const loanId = yield select((state) => state.quickpay.data.loanId);
  yield call(request({
    type: QuickpayConstants.ADD_PAYMENT_ACCOUNT,
    method: 'POST',
    url: urls.getQuickpayPaymentAccounts(loanId),
  }), action);
  yield put(getPaymentAccountsAction());
}

function* getQuickpayStatus(action) {
  const loanId = yield select((state) => state.quickpay.data.loanId);
  yield call(request({
    type: QuickpayConstants.GET_STATUS,
    method: 'GET',
    url: urls.getQuickpayStatus(loanId),
  }), action);
}

function* makeQuickpayPayment(action) {
  const loanId = yield select((state) => state.quickpay.data.loanId);
  yield call(request({
    type: QuickpayConstants.MAKE_QUICKPAY_PAYMENT,
    method: 'POST',
    url: urls.makeQuickpayPayment(loanId),
  }), action);
}

function* getQuickpayAutopays(action) {
  const loanId = yield select((state) => state.quickpay.data.loanId);
  yield call(request({
    type: QuickpayConstants.GET_AUTOPAYS,
    method: 'GET',
    url: urls.getQuickpayAutopays(loanId),
  }), action);
}

function* scheduleQuickpayAutopay(action) {
  const loanId = yield select((state) => state.quickpay.data.loanId);
  yield call(request({
    type: QuickpayConstants.SCHEDULE_AUTOPAY,
    method: 'POST',
    url: urls.getQuickpayAutopays(loanId),
  }), action);
}

function* updateDebitCard(action) {
  const loanId = yield select((state) => state.quickpay.data.loanId);
  const { paymentAccountId } = action.payload;
  yield call(request({
    type: QuickpayConstants.UPDATE_DEBIT_CARD,
    method: 'PUT',
    url: urls.updateDebitCard(loanId, paymentAccountId),
  }), action);
}

function* validateBankRoutingNumber(action) {
  const { routingNumber } = action.payload;
  yield call(request({
    type: QuickpayConstants.VALIDATE_BANK_ROUTING_NUMBER_QUICKPAY,
    method: 'GET',
    url: urls.validateRoutingNumber({ routingNumber, isQuickpay: true }),
  }), action);
}

function* submitBorrowerSelfIdentification(action) {
  yield call(request({
    type: QuickpayConstants.SUBMIT_BORROWER_SELF_IDENTIFICATION,
    method: 'POST',
    url: urls.postBorrowerSelfIdentification(),
  }), action);
}

function* getQuickpayCollateralSummary(action) {
  const loanId = get(action, 'payload.loanId') || (yield select((state) => state.quickpay.data.loanId));
  if (!loanId) {
    return;
  }

  yield call(request({
    type: QuickpayConstants.GET_COLLATERAL_SUMMARY,
    method: 'GET',
    url: urls.getQuickpayCollateralSummary(loanId),
  }), action);
}

function* getQuickpayCollateralRequired(action) {
  const loanId = get(action, 'payload.loanId') || (yield select((state) => state.quickpay.data.loanId));
  if (!loanId) {
    return;
  }

  yield call(request({
    type: QuickpayConstants.GET_COLLATERAL_REQUIRED,
    method: 'GET',
    url: urls.getQuickpayCollateralRequired(loanId),
  }), action);
}

function* getQuickpayLoanSetup(action) {
  const loanId = get(action, 'payload.loanId') || (yield select((state) => state.quickpay.data.loanId));
  if (!loanId) {
    return;
  }

  yield call(request({
    type: QuickpayConstants.GET_LOAN_SETUP,
    method: 'GET',
    url: urls.getQuickpayLoanSetup(loanId),
  }), action);
}

const quickpaySaga = function* () {
  yield takeEvery(QuickpayConstants.GET_QUICKPAY, getQuickpay);
  yield takeEvery(QuickpayConstants.GET_PAYMENT_ACCOUNTS, getPaymentAccounts);
  yield takeEvery(QuickpayConstants.ADD_PAYMENT_ACCOUNT, addPaymentAccounts);
  yield takeEvery(QuickpayConstants.GET_STATUS, getQuickpayStatus);
  yield takeEvery(QuickpayConstants.MAKE_QUICKPAY_PAYMENT, makeQuickpayPayment);
  yield takeEvery(QuickpayConstants.GET_AUTOPAYS, getQuickpayAutopays);
  yield takeEvery(QuickpayConstants.SCHEDULE_AUTOPAY, scheduleQuickpayAutopay);
  yield takeEvery(QuickpayConstants.SUBMIT_BORROWER_SELF_IDENTIFICATION, submitBorrowerSelfIdentification);
  yield takeEvery(QuickpayConstants.VALIDATE_BANK_ROUTING_NUMBER_QUICKPAY, validateBankRoutingNumber);
  yield takeEvery(QuickpayConstants.UPDATE_DEBIT_CARD, updateDebitCard);
  yield takeEvery(QuickpayConstants.GET_COLLATERAL_SUMMARY, getQuickpayCollateralSummary);
  yield takeEvery(QuickpayConstants.GET_COLLATERAL_REQUIRED, getQuickpayCollateralRequired);
  yield takeEvery(QuickpayConstants.GET_LOAN_SETUP, getQuickpayLoanSetup);
};

export default quickpaySaga;
